export const checkIfLetter = (value: string): boolean => {
  const lastChar = value.slice(-1);
  const reg: RegExp = /[\p{L}\s\p{P}]/u;

  if (!lastChar) return false;
  return reg.test(lastChar);
};
